var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-card",
            {
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c("b-skeleton", {
                        staticClass: "px-3",
                        attrs: { width: "30%", height: "1rem" },
                      }),
                      _vm._v(" "),
                      _c("b-skeleton", {
                        staticClass: "px-3",
                        attrs: { width: "60%", height: "1rem" },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c("b-skeleton", {
                staticClass: "px-3",
                attrs: { width: "100%", height: "20rem" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-card",
            {
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c("b-skeleton", {
                        staticClass: "px-3",
                        attrs: { width: "30%", height: "1rem" },
                      }),
                      _vm._v(" "),
                      _c("b-skeleton", {
                        staticClass: "px-3",
                        attrs: { width: "60%", height: "1rem" },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c("b-skeleton", {
                staticClass: "px-3",
                attrs: { width: "100%", height: "20rem" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }